module.exports = __webpack_public_path__ + "assets/war_white.2c6d7d52.svg";